module.exports = __webpack_public_path__ + "img/logo-new.59a46b45.png";